import { arrayToSelectOptions } from '../../common/utils/arrays';
import { resourceHiredState, resourceStatus } from '../../person/mockData';

export const RESOURCE_STATUS = arrayToSelectOptions(resourceStatus);
export const RESOURCE_STATE = arrayToSelectOptions(resourceHiredState);
export const TEMPLATE_ID = 'templateId';

export const RESOURCE_FIELD_NAMES = {
    name: 'name',
    type: 'type',
    resourceCategory: 'resourceCategory',
    role: 'role',
    budgetCategory: 'budgetCategory',
    status: 'status',
    locations: 'locations',
    summaryAbout: 'summary.about',
    resourceScheduleDateRangeDurationSpecified: 'resourceSchedule.dateRange.durationSpecified',
    resourceScheduleDateRange: 'resourceSchedule.dateRange',
    scheduleSection: 'schedule.section',
    subType: 'subType',
    hiringInfoSection: 'hiring.info.section',
    acquisitionLead: 'acquisitionLead',
    hiringTeamMembers: 'hiringTeamMembers',
    hiredPerson: 'hiredPerson',
    hiredOrganization: 'hiredOrganization',
    state: 'state',
    terms: 'terms'
};

export const RESOURCE_TYPE = {
    crew: 'Crew',
    cast: 'Cast',
    corporate: 'Corporate',
    hiring: 'hiring',
    procurement: 'procurement',
    supplier: 'Supplier'
};

export const RESOURCE_TYPES_PEOPLE_PREVIEW = [RESOURCE_TYPE.crew, RESOURCE_TYPE.cast, RESOURCE_TYPE.corporate];
